import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    InjectionToken,
    Injector,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

export type TDataFieldEditLanguagesComponent_Settings = {
    applicationLanguages: any[];
    contentLanguages: any[];
    onApplicationLanguageChangeFunc: ($event: FiApplicationLanguageType) => void;
    isRadioButtonLayout?: boolean;
};

export const DataFieldEditLanguagesComponent_Settings = new InjectionToken('DataFieldEditLanguagesComponent_Settings');

@Component({
    selector: 'data-field-edit-languages',
    templateUrl: './languages.component.html',
    styleUrls: ['./languages.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-languages' },
    standalone: false,
})
export class DataFieldEditLanguagesComponent extends DataFieldEditBase implements OnInit {
    applicationLanguageListData = new DropdownSettingsModelV2<IContentLanguage>({
        filterBy: 'Name',
    });
    preferredContentLanguageListData = new DropdownSettingsModelV2<IContentLanguage>({
        filterBy: 'Name',
    });

    constructor(
        injector: Injector,
        @Inject(DataFieldEditLanguagesComponent_Settings) public settings: TDataFieldEditLanguagesComponent_Settings,
        private contentLanguagesService: ContentLanguagesService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.setLanguagesListsData();
    }

    private setLanguagesListsData() {
        this.applicationLanguageListData.setDataSet(this.settings.applicationLanguages);

        this.preferredContentLanguageListData.setDataSet(this.settings.contentLanguages);
        this.contentLanguagesService.UpdateContentLanguageNames(this.preferredContentLanguageListData.dataSet);
    }

    onApplicationLanguageChange($event: FiApplicationLanguageType) {
        if (this.settings.onApplicationLanguageChangeFunc) this.settings.onApplicationLanguageChangeFunc($event);
    }

    isRadioButtonLayout(): boolean {
        return this.settings?.isRadioButtonLayout;
    }
}
